import PropTypes from 'prop-types';
import blocksShuffleSpinner from 'shared/assets/icons/blocks-shuffle-3.svg';

import './opSchedulerSpinner.css';

function OpSchedulerSpinner({ size }) {
  const imgStyle = {
    height: size,
    filter: 'invert(32%) sepia(97%) saturate(4268%) hue-rotate(154deg) brightness(90%) contrast(101%)',
  };

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <div className="op-scheduler-spinner" style={{ width: size, height: size }}>
        <img src={blocksShuffleSpinner} alt="" style={imgStyle} />
      </div>
    </div>
  );
}

OpSchedulerSpinner.propTypes = {
  size: PropTypes.string,
};

OpSchedulerSpinner.defaultProps = {
  size: '40px',
};

export default OpSchedulerSpinner;
